import { useMutation } from "@tanstack/react-query";
import { AttendanceAPI } from "../api";

export const useCreateAttendance = () => {
  return useMutation({
    mutationFn: ({
      attendanceType,
      remarks,
      deviceID,
      sourceType,
      fileAttached,
      location,
    }) =>
      AttendanceAPI.createAttendance({
        attendanceType,
        remarks,
        deviceID,
        sourceType,
        fileAttached,
        location,
      }),
    onError: (error) => {
      console.error("Create Attendance Failed: ", error.response || error);
    },
  });
};

export const useGetAllAttendancePaginated = () => {
  return useMutation({
    mutationFn: ({ page, pageSize, filters }) =>
      AttendanceAPI.getAllPaginated({ page, pageSize, filters }),
    onError: (error) => {
      console.error("Get All Attendance Failed: ", error.response || error);
    },
  });
};

export const useGetLatestAttendance = () => {
  return useMutation({
    mutationFn: () => AttendanceAPI.getLastAttendance(),
    onError: (error) => {
      console.error("Get Latest Attendance Failed: ", error.response || error);
    },
  });
};

export const useCreateOfficialBusiness = () => {
  return useMutation({
    mutationFn: ({
      obDateFrom,
      obDateTo,
      obTimeFrom,
      obTimeTo,
      reason,
      mediaID,
    }) =>
      AttendanceAPI.createOfficialBusiness({
        obDateFrom,
        obDateTo,
        obTimeFrom,
        obTimeTo,
        reason,
        mediaID,
      }),
    onError: (error) => {
      console.error(
        "Create Official Business Failed: ",
        error.response || error
      );
    },
  });
};

export const useGetAllOBPaginated = () => {
  return useMutation({
    mutationFn: ({ page, pageSize, filters }) =>
      AttendanceAPI.getAllOBPaginated({ page, pageSize, filters }),
    onError: (error) => {
      console.error("Get All OB Failed: ", error.response || error);
    },
  });
};
